import { APPAUTH_USERNAME_KEY } from "../..";

export const createUserFromToken = (token: string) => {
    let base64Url = token.split(".")[1];
    let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    let jsonPayload = decodeURIComponent(
        window
            .atob(base64)
            .split("")
            .map(function (c) {
                return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
    );

    return JSON.parse(jsonPayload);
}

export const isAppAuthModules = (): boolean => {
    return (window as any).geotabModules && (window as any).geotabModules.auth ? true : false;
};

export const isAppAuthLogin = (): boolean => {
    return localStorage.getItem(APPAUTH_USERNAME_KEY) ? true : false;
};

export const isAppAuthLogout = (): boolean => {
    return (window as any).geotabModules.auth["logout"] ? true : false
}

export const isGetTokenModule = (): boolean => {
    return (window as any).geotabModules && (window as any).geotabModules.auth && (window as any).geotabModules.auth["getToken"] ? true : false;
};

/**
 * Whether Drive is running in the React Native WebView shell with its AppAuth
 * token bridge available. Other MobileSDK containers must continue to follow
 * the feature-flag rollout for AppAuth.
 */
export const isReactNativeAppAuthContainer = (): boolean => {
    const reactNativeWebView = (window as any).ReactNativeWebView;
    return typeof reactNativeWebView?.postMessage === "function" && isGetTokenModule();
};
